var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import isArray from 'lodash/isArray';
import IconDefault from './IconDefault';
var scriptUrlCache = new Set();
var isValidScriptUrl = function (scriptUrl) {
    return Boolean(scriptUrl.length && !scriptUrlCache.has(scriptUrl));
};
var createScriptUrlElements = function (scriptUrls, index) {
    if (index === void 0) { index = 0; }
    var currentScriptUrl = scriptUrls[index];
    if (isValidScriptUrl(currentScriptUrl)) {
        var script = document.createElement('script');
        script.setAttribute('src', currentScriptUrl);
        script.setAttribute('data-namespace', currentScriptUrl);
        if (scriptUrls.length > index + 1) {
            script.onload = function () {
                createScriptUrlElements(scriptUrls, index + 1);
            };
            script.onerror = function () {
                createScriptUrlElements(scriptUrls, index + 1);
            };
        }
        scriptUrlCache.add(currentScriptUrl);
        document.body.appendChild(script);
    }
};
var createFromIconfontCN = function (props) {
    var scriptUrl = props.scriptUrl, extraCommonProps = props.extraCommonProps;
    if (scriptUrl
        && typeof document !== undefined
        && typeof window !== undefined
        && typeof document.createElement === 'function') {
        createScriptUrlElements(isArray(scriptUrl) ? scriptUrl.reverse() : [scriptUrl]);
    }
    var IconFont = function (props) {
        var type = props.type, children = props.children, restProps = __rest(props, ["type", "children"]);
        var content = null;
        if (type) {
            content = React.createElement("use", { xlinkHref: "#".concat(type) });
        }
        if (children) {
            content = children;
        }
        return (React.createElement(IconDefault, __assign({}, extraCommonProps, restProps), content));
    };
    return IconFont;
};
export default createFromIconfontCN;
